import * as $runtime from "../runtime.js";
import * as Data$dEither from "../Data.Either/index.js";
import * as Data$dInt from "../Data.Int/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as JSON$dInternal from "../JSON.Internal/index.js";
import {_null, fromBoolean, fromInt, fromJArray, fromJObject, fromString, print, printIndented} from "./foreign.js";
const parse = j => JSON$dInternal._parse(Data$dEither.Left, Data$dEither.Right, j);
const $$null = _null;
const fromNumberWithDefault = fallback => n => JSON$dInternal._fromNumberWithDefault(fallback, n);
const fromNumber = n => JSON$dInternal._fromNumberWithDefault(0, n);
const fromArray = js => fromJArray(JSON$dInternal.fromArray(js));
const fail = v => Data$dMaybe.Nothing;
const toBoolean = json => JSON$dInternal._case(fail, Data$dMaybe.Just, fail, fail, fail, fail, json);
const toJArray = json => JSON$dInternal._case(fail, fail, fail, fail, Data$dMaybe.Just, fail, json);
const toArray = json => {
  const $0 = JSON$dInternal._case(fail, fail, fail, fail, Data$dMaybe.Just, fail, json);
  if ($0.tag === "Just") { return Data$dMaybe.$Maybe("Just", JSON$dInternal.toArray($0._1)); }
  return Data$dMaybe.Nothing;
};
const toJObject = json => JSON$dInternal._case(fail, fail, fail, fail, fail, Data$dMaybe.Just, json);
const toNull = json => JSON$dInternal._case(Data$dMaybe.Just, fail, fail, fail, fail, fail, json);
const toNumber = json => JSON$dInternal._case(fail, fail, Data$dMaybe.Just, fail, fail, fail, json);
const toInt = a => {
  const $0 = JSON$dInternal._case(fail, fail, Data$dMaybe.Just, fail, fail, fail, a);
  if ($0.tag === "Just") { return Data$dInt.fromNumber($0._1); }
  if ($0.tag === "Nothing") { return Data$dMaybe.Nothing; }
  $runtime.fail();
};
const toString = json => JSON$dInternal._case(fail, fail, fail, Data$dMaybe.Just, fail, fail, json);
const case_ = a => b => c => d => e => f => json => JSON$dInternal._case(a, b, c, d, e, f, json);
export {case_, fail, fromArray, fromNumber, fromNumberWithDefault, $$null as null, parse, toArray, toBoolean, toInt, toJArray, toJObject, toNull, toNumber, toString};
export * from "./foreign.js";
